import { formatRfidDate, formatRfidDateTime } from "./utils/statusBadge";
import { getRfidRowId, getRfidHistoryKey } from "./utils/rfidHistoryUtils";

const displayValue = (value, fallback = "N/A") => {
  if (value === null || value === undefined || value === "" || value === "-") {
    return fallback;
  }
  return value;
};

export const RFID_EXPORT_COLUMNS = [
  "S.No",
  "Asset Code",
  "Asset Type",
  "Asset Category",
  // "RFID Device",
  "IMEI/SL/MFG",
  "Zone",
  "Ward",
  "Location/Landmark",
  "Installed Area",
  "Other No",
  "Collection Type",
  "Vehicle Type",
  "Vehicle Capacity",
  "Owner Type",
  "Date Of Installation",
  "Warranty Expire Date",
  "Purchase Date",
  "Insurance No",
  "Insurance Validity",
  "Insurance Provider",
  "Installed By",
  "Last Modified On",
  "Status",
];

export const mapRfidRowsForExport = (rfidData = []) =>
  (rfidData ?? []).map((row, index) => [
    index + 1,
    displayValue(row.rfidCode),
    displayValue(row.rfidTypeName ?? row.assetTypeName),
    displayValue(row.rfidCategoryName ?? row.assetCategoryName),
    // displayValue(row.rfidDeviceName),
    displayValue(row.imeiSlMfgNo),
    displayValue(row.zoneName),
    displayValue(row.wardNo),
    displayValue(row.locationLandmark),
    displayValue(row.installedArea),
    displayValue(row.otherNo),
    displayValue(
      row.collectionTypeName ??
        row.CollectionTypeName ??
        row.collectionType ??
        row.CollectionType
    ),
    displayValue(
      row.vehicleTypeName ?? row.VehicleTypeName ?? row.vehicleType ?? row.VehicleType
    ),
    displayValue(
      row.vehicleCapacityName ??
        row.VehicleCapacityName ??
        row.vehicleCapacity ??
        row.VehicleCapacity
    ),
    displayValue(
      row.ownerTypeName ?? row.OwnerTypeName ?? row.ownerType ?? row.OwnerType
    ),
    formatRfidDate(row.dateOfInstallation),
    formatRfidDate(row.warrantyExpireDate),
    formatRfidDate(row.purchaseDate),
    displayValue(row.insuranceNo),
    formatRfidDate(row.insuranceValidity),
    displayValue(row.insuranceProvider),
    displayValue(row.installedBy),
    formatRfidDate(row.lastModifiedOn),
    row.isActive ? "Active" : "Inactive",
  ]);

export const RFID_HISTORY_COLUMNS = [
  "S.No",
  "Status",
  "Remarks",
  "Action Taken By",
  "Modified On",
];

export const getHistoryForRow = (row, historyById = {}) => {
  const id = getRfidHistoryKey(getRfidRowId(row));
  if (id && historyById[id]?.length) return historyById[id];
  if (row?.history?.length) return row.history;
  return [];
};

export const mapHistoryRowsForExport = (history = []) =>
  history.map((item, index) => [
    item.sNo ?? index + 1,
    item.statusName || "N/A",
    item.remarks || "N/A",
    item.actionTakenBy || "N/A",
    formatRfidDateTime(item.modifiedOn),
  ]);

export const loadAllRfidHistory = async (rfidData = [], fetchRfidHistory) => {
  const historyById = {};

  await Promise.all(
    rfidData.map(async (row) => {
      const id = getRfidHistoryKey(getRfidRowId(row));
      if (!id) return;

      try {
        const history = await fetchRfidHistory(id);
        historyById[id] = history?.length ? history : row.history || [];
      } catch {
        historyById[id] = row.history || [];
      }
    })
  );

  return historyById;
};

export const getExportDateTime = () => {
  const now = new Date();
  const date = `${now.getDate()}-${now.getMonth() + 1}-${now.getFullYear()}`;
  const time = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
  return `RFID List Generated on: ${date}, ${time}`;
};
